import dynamic from 'next/dynamic';

const NavbarOnly = dynamic(() => import('./NavbarOnly'), { ssr: true });

export default NavbarOnly;
